<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <input class="form-control"  [type]="inputType" [formControlName]="field.name" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}">
    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>
</div>
